import React from "react";
import {Box, Stack, Typography, IconButton, Button, Modal, Fade} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Cancel01Icon} from "@hugeicons/core-free-icons";

export const ConfirmModalNew = ({open, onClose, onConfirm, title = "Are you sure?", description = "This action is permanent and cannot be undone.", confirmText = "Delete", cancelText = "Cancel", loading = false}) => {
    return (
        <Modal open={open} onClose={onClose}>
            <Fade in={open}>
                <Box sx={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: {xs: "calc(100% - 24px)", md: "min(480px, 92vw)"}, bgcolor: '#fff', borderRadius: '20px', boxShadow: '0 24px 70px rgba(35, 38, 77, 0.22)', p: {xs: 2.5, md: 3}, outline: 'none'}}>
                    <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{mb: 2}}>
                        <Box sx={{minWidth: 0}}>
                            <Typography sx={{fontSize: 18, fontWeight: 700, color: '#23264D', letterSpacing: '-0.01em', wordBreak: 'break-word'}}>{title}</Typography>
                            <Typography sx={{fontSize: 13, color: '#8A8AA0', mt: 0.75, wordBreak: 'break-word'}}>{description}</Typography>
                        </Box>
                        <IconButton size="small" onClick={onClose} sx={{color: '#8A8AA0', mt: -0.5}}><HugeiconsIcon icon={Cancel01Icon} size={18}/></IconButton>
                    </Stack>

                    <Stack direction="row" gap={1.5} justifyContent="flex-end" sx={{mt: 3}}>
                        <Button onClick={onClose} sx={{textTransform: 'none', fontWeight: 600, fontSize: 13, borderRadius: '10px', color: '#374151', bgcolor: '#FAFAFD', '&:hover': {bgcolor: '#ECECF3'}}}>{cancelText}</Button>
                        <Button disabled={loading} onClick={onConfirm} sx={{textTransform: 'none', fontWeight: 600, fontSize: 13, borderRadius: '10px', bgcolor: '#DC2626', color: '#fff', '&:hover': {bgcolor: '#B91C1C'}, '&.Mui-disabled': {bgcolor: '#D1D5DB', color: '#9CA3AF'}}}>{loading ? "Deleting..." : confirmText}</Button>
                    </Stack>
                </Box>
            </Fade>
        </Modal>
    );
};

export default ConfirmModalNew;
